import { render, staticRenderFns } from "./addRoleModal.vue?vue&type=template&id=2c46d94d&scoped=true"
import script from "./addRoleModal.vue?vue&type=script&lang=js"
export * from "./addRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c46d94d",
  null
  
)

export default component.exports